import React, { useEffect } from "react";
import { IoChevronBack, IoChevronForward, IoClose } from "react-icons/io5";
import { MdDownload } from "react-icons/md";
import "../../assets/css/component-media-gallery.css";

const IMAGE_FORMATS = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "tiff", "svg"];

export default function MediaGalleryModal({
  media,
  currentIndex,
  isOpen,
  onClose,
  onPrev,
  onNext,
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
      else if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onPrev, onNext, onClose]);

  if (!isOpen || !media.length) return null;

  const current = media[currentIndex];
  const isImage = IMAGE_FORMATS.includes(current.format);

  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = current.url;
    link.download = current.nom || "media";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="media-gallery-backdrop" onClick={onClose}>
      <button className="media-gallery-close" onClick={onClose}>
        <IoClose />
      </button>

      <span className="media-gallery-counter">
        {currentIndex + 1} / {media.length}
      </span>

      <button className="file-preview-download" onClick={handleDownload}>
        <MdDownload />
      </button>

      {currentIndex > 0 && (
        <button
          className="media-gallery-arrow media-gallery-arrow--left"
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
        >
          <IoChevronBack />
        </button>
      )}

      <div
        className="media-gallery-content"
        onClick={(e) => e.stopPropagation()}
      >
        {isImage ? (
          <img src={current.url} alt={current.nom || ""} />
        ) : (
          <video src={current.url} controls autoPlay />
        )}
      </div>

      {currentIndex < media.length - 1 && (
        <button
          className="media-gallery-arrow media-gallery-arrow--right"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
        >
          <IoChevronForward />
        </button>
      )}
    </div>
  );
}
